import createIcon from '@/lib/create-icon'

const NascarIcon = createIcon(
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='18'
    height='18'
    viewBox='0 0 46 46'
    fill='none'
  >
    <path
      d='M11.5 27.7915H15.3333M30.6667 27.7915H34.5M8.625 21.0832L5.75 17.2498M8.625 21.0832H37.375M8.625 21.0832L10.8507 10.6966C11.2294 8.92921 12.7914 7.6665 14.5989 7.6665H31.4011C33.2086 7.6665 34.7706 8.9292 35.1493 10.6966L37.375 21.0832M37.375 21.0832L40.25 17.2498M9.58333 34.4998H36.4167M9.58333 34.4998C7.46624 34.4998 5.75 32.7836 5.75 30.6665V24.9165C5.75 22.7994 7.46624 21.0832 9.58333 21.0832H36.4167C38.5338 21.0832 40.25 22.7994 40.25 24.9165V30.6665C40.25 32.7836 38.5338 34.4998 36.4167 34.4998M9.58333 34.4998H17.25V36.4165C17.25 38.5336 15.5338 40.2498 13.4167 40.2498C11.2996 40.2498 9.58333 38.5336 9.58333 36.4165L9.58333 34.4998ZM36.4167 34.4998H28.75V36.4165C28.75 38.5336 30.4662 40.2498 32.5833 40.2498C34.7004 40.2498 36.4167 38.5336 36.4167 36.4165V34.4998Z'
      stroke='url(#paint0_linear_5314_558)'
      strokeWidth='2.875'
      strokeLinecap='round'
      strokeLinejoin='round'
      fill='none'
    />
    <path
      d='M11.5 27.7915H15.3333M30.6667 27.7915H34.5M8.625 21.0832L5.75 17.2498M8.625 21.0832H37.375M8.625 21.0832L10.8507 10.6966C11.2294 8.92921 12.7914 7.6665 14.5989 7.6665H31.4011C33.2086 7.6665 34.7706 8.9292 35.1493 10.6966L37.375 21.0832M37.375 21.0832L40.25 17.2498M9.58333 34.4998H36.4167M9.58333 34.4998C7.46624 34.4998 5.75 32.7836 5.75 30.6665V24.9165C5.75 22.7994 7.46624 21.0832 9.58333 21.0832H36.4167C38.5338 21.0832 40.25 22.7994 40.25 24.9165V30.6665C40.25 32.7836 38.5338 34.4998 36.4167 34.4998M9.58333 34.4998H17.25V36.4165C17.25 38.5336 15.5338 40.2498 13.4167 40.2498C11.2996 40.2498 9.58333 38.5336 9.58333 36.4165L9.58333 34.4998ZM36.4167 34.4998H28.75V36.4165C28.75 38.5336 30.4662 40.2498 32.5833 40.2498C34.7004 40.2498 36.4167 38.5336 36.4167 36.4165V34.4998Z'
      stroke='white'
      strokeOpacity='0.04'
      strokeWidth='2.875'
      strokeLinecap='round'
      strokeLinejoin='round'
      fill='none'
    />
    <path
      d='M11.5 27.7915H15.3333M30.6667 27.7915H34.5M8.625 21.0832L5.75 17.2498M8.625 21.0832H37.375M8.625 21.0832L10.8507 10.6966C11.2294 8.92921 12.7914 7.6665 14.5989 7.6665H31.4011C33.2086 7.6665 34.7706 8.9292 35.1493 10.6966L37.375 21.0832M37.375 21.0832L40.25 17.2498M9.58333 34.4998H36.4167M9.58333 34.4998C7.46624 34.4998 5.75 32.7836 5.75 30.6665V24.9165C5.75 22.7994 7.46624 21.0832 9.58333 21.0832H36.4167C38.5338 21.0832 40.25 22.7994 40.25 24.9165V30.6665C40.25 32.7836 38.5338 34.4998 36.4167 34.4998M9.58333 34.4998H17.25V36.4165C17.25 38.5336 15.5338 40.2498 13.4167 40.2498C11.2996 40.2498 9.58333 38.5336 9.58333 36.4165L9.58333 34.4998ZM36.4167 34.4998H28.75V36.4165C28.75 38.5336 30.4662 40.2498 32.5833 40.2498C34.7004 40.2498 36.4167 38.5336 36.4167 36.4165V34.4998Z'
      stroke='url(#paint1_radial_5314_558)'
      strokeOpacity='0.6'
      strokeWidth='2.875'
      strokeLinecap='round'
      strokeLinejoin='round'
      fill='none'
    />
    <defs>
      <linearGradient
        id='paint0_linear_5314_558'
        x1='5.75'
        y1='7.6665'
        x2='43.6938'
        y2='35.5663'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#E90083' />
        <stop offset='1' stopColor='#FF6864' />
      </linearGradient>
      <radialGradient
        id='paint1_radial_5314_558'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(23 40.2498) scale(17.25 16.5926)'
      >
        <stop stopColor='white' />
        <stop offset='1' stopColor='#754660' stopOpacity='0' />
      </radialGradient>
    </defs>
  </svg>,
  'NascarIcon'
)

export default NascarIcon
